import { createThunkEffect } from "../../utilities/ActionUtility";
import * as MessageEffect from "./MessageEffect";

export const CONTACT_REQUEST = "MessageEffect.CONTACT_REQUEST";
export const CONTACT_REQUEST_FINISHED = "MessageEffect.CONTACT_REQUEST_FINISHED";

export function sendContactRequest(details) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, CONTACT_REQUEST, MessageEffect.sendContactRequest, details);
    };
}

export const SUBSCRIPTION_REQUEST = "MessageEffect.SUBSCRIPTION_REQUEST";
export const SUBSCRIPTION_REQUEST_FINISHED = "MessageEffect.SUBSCRIPTION_REQUEST_FINISHED";

export function sendSubscriptionRequest(details) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, SUBSCRIPTION_REQUEST, MessageEffect.sendSubscriptionRequest, details);
    };
}

export const REQUEST_SEND_EMAIL_TO_SUBSCRIPTION_USER = "MessageEffect.REQUEST_SEND_EMAIL_TO_SUBSCRIPTION_USER";
export const REQUEST_SEND_EMAIL_TO_SUBSCRIPTION_USER_FINISHED = "MessageEffect.REQUEST_SEND_EMAIL_TO_SUBSCRIPTION_USER_FINISHED";

export function sendEmailToSubscriptionUser(userId, subscriptionTypeId) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_SEND_EMAIL_TO_SUBSCRIPTION_USER, MessageEffect.sendEmailToSubscriptionUser, userId, subscriptionTypeId);
    };
}